export default __webpack_public_path__ + "static/media/terms-of-service-consent-kr-4.1ae97e12.jpg";